export const loginSuccess = "Login successful!";
export const loginFail = "Login failed! Invalid Credentials!";

export const signupSuccess = "Signup successful! ";
export const signupFail = "Signup failed! ";

export const updateSuccess = "Update successful! ";
export const updateFail = "Update failed! ";

export const projectAddSuccess = "Project added successfully!";
export const projectAddFail = "Project addition failed! ";

export const clientAddSuccess = "Client added successfully!";
export const clientAddFail = "Client addition failed! ";

export const materialAddSuccess = "Material added successfully!";
export const materialAddFail = "Material addition failed! ";

export const activityAddSuccess = "Activity added successfully!";
export const activityAddFail = "Activity addition failed! ";

export const employeeAddSuccess = "Employee added successfully!";
export const employeeAddFail = "Employee addition failed! ";